import { useState } from "react";
import styles from "./AddTeam.module.scss";

const team: Array<{
  id: string;
  name: string;
  email: string;
  organisation: string;
  sector: string;
  enabled: boolean;
}> = [
  {
    id: "3",
    name: "Pepijn Herman",
    email: "Pepijn.mail.com",
    organisation: "Brabantse Ontwikkelingsmaatschappij",
    sector: "High-Tech",
    enabled: false,
  },
  {
    id: "4",
    name: "Rob Dal",
    email: "Rob.mail.com",
    organisation: "Horizon",
    sector: "Soft-Tech",
    enabled: false,
  },
  {
    id: "5",
    name: "Roel Franken",
    email: "Roel.mail.com",
    organisation: "ROM Utrecht",
    sector: "Soft-Tech",
    enabled: false,
  },
  {
    id: "6",
    name: "Pieter Meuwissen ",
    email: "Pieter.mail.com",
    organisation: "Brabantse Ontwikkelingsmaatschappij",
    sector: "Agrofood",
    enabled: false,
  },
];

const applyFilters = (teamMembers: any[], query: string) => {
  const searchStrings = query
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim()
    .split(" ");

  return teamMembers.filter(({ name }) => {
    const visorInfo = name.toLowerCase();
    return searchStrings.every((el: string) =>
      visorInfo.includes(el.toLowerCase())
    );
  });
};

type AddTeamProps = {
  show: boolean;
  onToggle: React.MouseEventHandler<HTMLButtonElement>;
};

export const AddTeam = ({show, onToggle}: AddTeamProps) => {

  const [teamMembers, setTeamMembers] = useState(team);

  const [search, setSearch] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [organisation, setOrganisation] = useState("");
  const [sector, setSector] = useState("");

  const filteredTeamMembers = applyFilters(teamMembers, search);

  const addTeamMember = () => {
    const newTeamMember = {
      id: Math.floor(Math.random() * 90 + 10).toString(),
      name,
      email,
      organisation,
      sector,
      enabled: false,
    };
    setTeamMembers([...teamMembers, newTeamMember]);
    setName("");
    setEmail("");
    setOrganisation("");
    setSector("");
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.title}>
          <span>Toevoegen</span>
          <span> - Data base</span>
        </div>
        <button className={styles.close} onClick={onToggle}>
          X
        </button>
      </div>
      <h2 className={styles.subtitle}>Teamleden</h2>
      <div className={styles.search}>
        <input
          type="text"
          placeholder="Zoeken..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className={styles.icon} />
      </div>
      <div className={styles.visors}>
        {filteredTeamMembers.map(
          ({ name, id, email, organisation, sector, enabled }) => (
            <div className={styles.visor} key={id}>
              <input
                type="checkbox"
                name="visor"
                id={id}
                defaultChecked={enabled}
                value={name}
              />
              <label
                htmlFor={id}
              >{`${name} | ${email} | ${organisation} | ${sector}`}</label>
            </div>
          )
        )}
      </div>
      <div className={styles.addVisor}>
        <p className={styles.description}>
          Staat de begeleider er niet bij? Geen probleem! Voeg zelf de
          begeleider toe om uit te nodigen voor deze editie.
        </p>
        <div className={styles.name}>
          <label htmlFor="name">Naam:</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className={styles.email}>
          <label htmlFor="email">Mail:</label>
          <input
            type="text"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className={styles.organisation}>
          <label htmlFor="organisation">Organisatie:</label>
          <input
            type="text"
            id="organisation"
            value={organisation}
            onChange={(e) => setOrganisation(e.target.value)}
          />
        </div>
        <div className={styles.sector}>
          <label htmlFor="organisation">Sector focus:</label>
          <input
            type="text"
            id="organisation"
            value={sector}
            onChange={(e) => setSector(e.target.value)}
          />
          <button
            className={styles.add}
            onClick={addTeamMember}
            disabled={!(name && email && organisation && sector)}
          >
            + Voeg toe
          </button>
        </div>
      </div>
      <button className={styles.save}>Opslaan</button>
    </div>
  );
};
